import { useContext, useEffect, useState } from "react";
import { FormContext } from "../context/FormContext";
import { getReference, getClientSettings } from "../services/apiService";
import { store } from "../app/store";
import { updateMaxHistory } from "../app/undoable";
import useUserInfoAndLogging from "../utils/useUserInfoAndLogging";
import { useAuth } from "../context/AuthContext";

const ClientSettings = ({ children }) => {
  const { isAuthenticated, getToken } = useAuth();
  const [settings, setSettings] = useState();
  const { logException } = useUserInfoAndLogging();
  const { dispatch } = useContext(FormContext);

  useEffect(() => {
    if (isAuthenticated) {
      const replaceClientSettings = async () => {
        const token = await getToken();
        const _clientSettings = await getClientSettings(token);
        if (_clientSettings instanceof Error) {
          logException(_clientSettings);
          document.title = "Error";
          return;
        }
        document.title = _clientSettings.general.displayName;
        const attribute = document.querySelector("html");
        attribute.style.setProperty(
          "--newColourblindMarkerColour",
          _clientSettings.general.stylingNewStatusAssetColourBlindColour,
        );
        attribute.style.setProperty(
          "--newMarkerColour",
          _clientSettings.general.stylingNewStatusAssetColour,
        );
        attribute.style.setProperty(
          "--replacementColourblindMarkerColour",
          _clientSettings.general.stylingReplacementStatusAssetColourBlindColour,
        );
        attribute.style.setProperty(
          "--replacementMarkerColour",
          _clientSettings.general.stylingReplacementStatusAssetColour,
        );
        dispatch({
          form: "clientSettings",
          obj: _clientSettings,
          type: "REPLACE_STATE",
        });
        dispatch({
          form: "originalClientSettings",
          obj: JSON.parse(JSON.stringify(_clientSettings)),
          type: "REPLACE_STATE",
        });
        const reference = await getReference(token);
        if (reference instanceof Error) {
          logException(reference);
          return;
        }
        dispatch({
          form: "reference",
          obj: reference,
          type: "REPLACE_STATE",
        });
        store.dispatch(updateMaxHistory(_clientSettings.general.maxHistory));
        setSettings(_clientSettings);
      };
      replaceClientSettings();
    }
  }, [isAuthenticated]);

  return <>{isAuthenticated && settings && children}</>;
};

export default ClientSettings;
